module.exports = __webpack_public_path__ + "img/72.afdbb57e.jpg";